import { useEffect, useRef } from 'react';
import CommonHeader from './commonheader/CommonHeader'
import Footer from './Footer'

const AboutUs = () => {
  const headingRef = useRef(null);
  
      useEffect(() => {
          const target = headingRef.current;
          if (!target) return;
  
          const observer = new IntersectionObserver(
              ([entry]) => {
                  if (entry.isIntersecting) {
                      target.classList.add('animate');
                      observer.unobserve(target);
                  }
              },
              { threshold: 0.5 }
          );
  
          observer.observe(target);
  
          return () => {
              observer.unobserve(target);
          };
      }, []);
  return (
    <div>
      <CommonHeader />

      <section className="about-us-page section-padding">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="aos-item">
                        <div className="aos-item__inner">
                            <h3 className="section-heading f-size-45 fw-bold mb-3 text-center" ref={headingRef}>
            <span className="qodef-e-inner">
                <span className="qodef--word">
                    {'About Us'.split('').map((char, index) => (
                        <span
                            className="qode--char"
                            style={{
                                '--qode-i': index,
                                marginRight: char === ' ' ? '16px' : '0px',
                            }}
                            key={index}
                        >
                            <span className="qode--char-inner">{char}</span>
                        </span>
                    ))}
                </span>
            </span>
        </h3>
                            <p className='text-center'>Embroidery is an art of intention — every stitch a quiet act of mastery, every thread a testament to patience and craft. India Embroidery Co. is an embroidery design house distinguished by its ideation, innovation, precision, and uncompromising attention to detail.</p>
                            <p className='text-center'>For us, Haute Couture represents the highest expression of imagination — a world of refined glamour where hand-embroidered and hand-sewn creations come to life as wearable art. At India Embroidery Co., we strive to unite contemporary vision with the richness of Indian heritage to create ensembles that set unparalleled trends.</p>
                            <p className='text-center'>Headquartered in Mumbai, India, the house is led by our Creative Director and CEO, Ms. Parul Bhargava, and our Founder and CMO, Vivek Jhaveri.</p>
                            <p className='text-center'>Ms. Parul Bhargava, an alumna of Central Saint Martins and the London College of Fashion, UK, is the second Indian to be certified in couture hand embroidery by the esteemed École Lesage, Paris — a distinction that places her among a select circle of global artisans. She brings exceptional mastery and precision to silk shading, tambour beading, Luneville hook techniques, and mixed-media embroidery, elevating each creation into an expression of enduring elegance.</p>
                            <p className='text-center'>Vivek Jhaveri, a third-generation businessman and entrepreneur, contributes by adding a refined sensibility shaped by his experience in high jewellery. His deep appreciation for art, design, and detail, enriches the house’s identity, infusing it with sharp business accumen and a strategic vision for growth.</p>
                            <p className='text-center'>At the core of our practice, lies an unwavering pursuit of excellence — a philosophy that beautifies every creation. We do not regard embroidery as mere ornamentation, but, as a living art form that imparts grace, character, and timeless sophistication to every surface that it touches. From ready-to-wear, haute couture, bridal, and accessories, our work is conceived to transcend fleeting trends and endure as treasured pieces.</p>
                            <p className='text-center'>As a contemporary design house, we follow ethical practice, sustainability, meticulous craftsmanship, and uphold the highest standards of quality throughout our manufacturing process. Our in-house atelier also offers expert sewing and corsetry for couture evening and bridalwear.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default AboutUs
